export function getApiOrigin(): string {
  if (
    location.hostname === 'localhost' ||
    location.hostname === '127.0.0.1' ||
    location.hostname === ''
  ) {
    // Development origin is a different port than webpack
    return 'https://localhost:5001';
  }
  return location.origin;
}
